"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleMainPrice = void 0;
const core_1 = require("@angular/core");
let VehicleMainPrice = class VehicleMainPrice {
    constructor() {
        this.mainPrice = null;
        this.mainPriceDefinition = '(Differenzbesteuert nach §25a UStG)';
        this.labelDescription = 'UPE';
    }
    ngOnChanges() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const rrpManufacturer = (_b = (_a = this.vehicle.vehicleData.price) === null || _a === void 0 ? void 0 : _a.retailPrices) === null || _b === void 0 ? void 0 : _b.manufacturer;
        const rrpInvoice = (_d = (_c = this.vehicle.vehicleData.price) === null || _c === void 0 ? void 0 : _c.retailPrices) === null || _d === void 0 ? void 0 : _d.invoice;
        const rrpOffer = (_f = (_e = this.vehicle.vehicleData.price) === null || _e === void 0 ? void 0 : _e.retailPrices) === null || _f === void 0 ? void 0 : _f.offer;
        this.labelDescription = 'UPE';
        if (rrpOffer && rrpOffer > 0) {
            this.mainPrice = rrpOffer;
        }
        else if (rrpInvoice && rrpInvoice > 0) {
            this.mainPrice = rrpInvoice;
        }
        else if (rrpManufacturer && rrpManufacturer > 0) {
            this.mainPrice = rrpManufacturer;
        }
        else {
            this.mainPrice = null;
            this.labelDescription = 'UPE';
        }
        if (this.mainPrice && ((_g = this.vehicle.vehicleData.price) === null || _g === void 0 ? void 0 : _g.includesVat)) {
            const vatRate = ((_h = this.vehicle.vehicleData.price) === null || _h === void 0 ? void 0 : _h.vatRate) || 0;
            this.mainPrice *= (vatRate + 1);
            this.mainPriceDefinition = `inkl. ${vatRate * 100}% MwSt.`;
        }
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleMainPrice.prototype, "vehicle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], VehicleMainPrice.prototype, "label", void 0);
VehicleMainPrice = __decorate([
    (0, core_1.Component)({
        selector: '[vehicle-main-price]',
        template: `
    <ng-container *ngIf="label" style="display:inline-flex;align-items:center;">
      <span>{{ labelDescription }}&nbsp;</span>
      <span *ngIf="mainPrice">{{ mainPrice | currency }}</span>
      <span *ngIf="!mainPrice">-</span>
    </ng-container>

    <ng-container *ngIf="mainPrice && !label" style="display:inline-flex;align-items:center;">
      {{ mainPrice | currency }}

      <svg class="ab-icon cell-icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
      <div class="hover-content left">
        <span>UPE {{ mainPriceDefinition }}</span>
      </div>
    </ng-container>
  `,
    })
], VehicleMainPrice);
exports.VehicleMainPrice = VehicleMainPrice;
